export default {

    "condition.Adgroup name": "广告组名称",
    "condition.Ad name": "广告名称",
    "condition.Ad set name": "广告组名称",
    "condition.Placement": "版位",
    "condition.Lifetime budget": "总预算",
    "condition.Daily budget": "单日预算",
    "condition.Bid amount": "竞价金额",
    "condition.Billing event": "付费事件",
    "condition.Optimization goal": "优化目标",

    "condition.Custom": "自定义",
    "condition.Increment CPA": "增量CPA",
    "condition.Budget": "预算",
    "condition.Spend Percent": "花费百分比",

  

    "condition.Basic Data": "基本数据",
	"condition.Most common": "最常见",
  "condition.Spent": "已花费",
  "condition.Lifetime spent": "总花费",
  "condition.Frequency": "频次",
  "condition.Results": "成效",
  "condition.Cost per result": "单次成效费用",
  "condition.Mobile app install": "移动应用安装",
  "condition.Cost per mobile app install": "单次移动应用安装费用",
  "condition.In-app purchase ROAS": "广告花费回报 (ROAS)-移动应用购物",
  "condition.Website purchase ROAS": "广告花费回报 (ROAS)-网站购物",
  "condition.Settings": "设置",
  "condition.Campaign name": "广告系列名称",
  "condition.Objective": "目标",
  "condition.Buying type": "购买类型",
  "condition.Spend cap": "花费上限",
  "condition.Daily ratio spent": "单日花费比率",
  "condition.Lifetime ratio spent": "总花费比率",
  "condition.Audience reached %": "受众覆盖 %",
  "condition.Website Conversions(Meta.Pixel)": "网站转化(Meta Pixel 像素代码)",
  "condition.All Website Conversions(Meta.Pixel)": "所有网站转化(Meta Pixel 像素代码)",
  "condition.Adds of Payment lnfo(Meta.Pixel)": "添加支付信息(Meta Pixel 像素代码)",
  "condition.Adds to Cart(Meta.Pixel)": "加入购物车(Meta Pixel 像素代码)",
  "condition.Adds to Wishlist(Meta.Pixel)": "加入心愿单(Meta Pixel 像素代码)",
  "condition.Registrations Completed(Meta.Pixel)": "完成注册(Meta Pixel 像素代码)",
  "condition.Checkouts Initiated(Meta.Pixel)": "发起结账(Meta Pixel 像素代码)",
  "condition.Leads (Meta Pixel)": "潜在客户(Meta Pixel 像素代码)",
  "condition.Purchases(Meta Pixel)": "购物(Meta Pixel 像素代码)",
  "condition.Searches (Meta Pixel)": "搜索(Meta Pixel 像素代码)",
  "condition.Content Views(Meta Pixel)": "内容查看(Meta Pixel 像素代码)",
  "condition.Other Website Conversions(Meta Pixel)": "其他网站转化(Meta Pixel 像素代码)",
  "condition.Cost per Website Conversion(Meta Pixel)": "单次网站转化费用(Meta Pixel 像素代码)",
  "condition.Cost per Add of Payment lnfo(Meta Pixel)": "单次添加支付信息费用(Meta Pixel 像素代码)",
  "condition.Cost per Add to Cart(Meta Pixel)": "单次加入购物车费用(Meta Pixel 像素代码)",
  "condition.Cost per Add to Wishlist(Meta Pixel)": "单次加入心愿单费用(Meta Pixel 像素代码)",
  "condition.Cost per Registration Completed(Meta Pixel)": "单次完成注册费用(Meta Pixel 像素代码)",
  "condition.Cost per Checkout Initiated(Meta Pixel)": "单次发起结账费用(Meta Pixel 像素代码)",
  "condition.Cost per Lead(Meta Pixel)": "单条潜客信息费用(Meta Pixel 像素代码)",
  "condition.Cost per Purchase(Meta Pixel)": "单次购物费用(Meta Pixel 像素代码)",
  "condition.Cost per Search(Meta Pixel)": "单次搜索费用(Meta Pixel 像素代码)",
  "condition.Cost per Content(Meta Pixel)": "单次内容查看费用(Meta Pixel 像素代码)",
  "condition.In-app events": "移动应用事件",
  "condition.All in-app events": "所有移动应用事件",
  "condition.In-app achievements unlocked": "移动应用解锁成就",
  "condition.In-app sessions": "移动应用会话",
  "condition.In-app adds of payment info": "移动应用添加支付信息",
  "condition.In-app adds to cart": "移动应用加入购物车",
  "condition.In-app adds to wishlist": "移动应用加入心愿单",
  "condition.In-app registrations completed": "完成注册(移动应用)",
  "condition.In-app content views": "移动应用内容查看",
  "condition.In-app checkouts initiated": "移动应用发起结账",
  "condition.In-app levels completed": "移动应用关卡完成",
  "condition.In-app purchases": "应用内购买",
  "condition.In-app ratings submitted": "移动应用提交评分",
  "condition.In-app searches": "移动应用搜索",
  "condition.In-app credits spent": "移动应用点数花费",
  "condition.In-app tutorials completed": "移动应用完成教程学习",
  "condition.Other in-app actions": "移动应用其他操作",
  "condition.Cost per in-app event": "单次移动应用事件费用",
  "condition.Cost per in-app achievement unlocked": "单次移动应用成就解锁费用",
  "condition.Cost per in-app session": "单次移动应用会话费用",
  "condition.Cost per in-app add of payment info": "单次移动应用添加支付信息费用",
  "condition.Cost per in-app add to cart": "单次移动应用加入购物车费用",
  "condition.Cost per in-app add to wishlist": "单次移动应用加入心愿单费用",
  "condition.Cost per in-app registration completed": "单次移动应用完成注册费用",
  "condition.Cost per in-app content view": "单次移动应用内容查看费用",
  "condition.Cost per in-app checkout initiated": "单次移动应用发起结账费用",
  "condition.Cost per in-app level completed": "单次移动应用关卡完成费用",
  "condition.Cost per in-app purchase": "单次移动应用购物费用",
  "condition.Cost per in-app rating submitted": "单次移动应用提交评分费用",
  "condition.Cost per in-app search": "单次移动应用搜索费用",
  "condition.Cost per in-app credit spent": "单次移动应用点数花费的广告费用",
  "condition.Cost per in-app tutorial completed": "单次移动应用完成教程学习费用",
  "condition.Offline conversions": "线下转化",
  "condition.All offline conversions": "所有线下转化",
  "condition.Offline adds of payment info": "线下添加支付信息",
  "condition.Offline adds to cart": "线下加入购物车",
  "condition.Offline adds to wishlist": "线下加入心愿单",
  "condition.Offline Registrations Completed": "完成注册(线下)",
  "condition.Offline checkouts Initiated": "线下发起结账",
  "condition.Offline leads": "线下潜在客户",
  "condition.Other offline conversions": "其他线下转化",
  "condition.Offline purchases": "线下购物",
  "condition.Offline searches": "线下搜索",
  "condition.Offline content views": "线下内容查看",
  "condition.Cost per offline conversion": "单次线下转化费用",
  "condition.Cost per offline add of payment info": "单次添加支付信息(线下)费用",
  "condition.Cost per offline add to cart": "单次线下加入购物车费用",
  "condition.Cost per offline registration completed": "单次完成线下注册费用",
  "condition.Cost per offline checkout initiated": "单次发起结账(线下)费用",
  "condition.Cost per offline lead": "单条线下潜客信息费用",
  "condition.Cost per other offline conversion": "单次其他操作费用(线下转化)",
  "condition.Cost per offline purchase": "单次线下购物费用",
  "condition.Cost per offline content view": "单次线下内容查看费用",
  "condition.Other": "其他",
  "condition.CPC (Link)": "单次点击费用(链接)",
  "condition.Link clicks": "链接点击量",
  "condition.CPM": "千次展示费用",
  "condition.CTR (Link)": "点击率(链接)",
  "condition.Lifetime impressions": "总展示量",
  "condition.Impressions": "展示次数",
  "condition.Reach": "覆盖人数",
  "condition.Leads": "潜在客户",
  "condition.Actions": "操作",
  "condition.Clicks": "点击量",
  "condition.CPA": "CPA",
  "condition.CPC": "CPC",
  "condition.CPP": "每点成本",
  "condition.CTR": "点击率",
  "condition.Result rate": "成效获得率",
  "condition.Cost per unique click": "单次独立点击费用",
  "condition.Unique clicks": "独立用户点击量",
  "condition.Today spent": "今日花费",
  "condition.Yesterday spent": "昨日花费",
  "condition.Post engagement": "帖文互动",
  "condition.Cost per post engagement": "单次帖文互动费用",
  "condition.3-Second video views": "观看视频达 3 秒的次数",
  "condition.Cost per video vlew": "单次视频观看费用",
  "condition.Page likes": "公共主页获赞数",
  "condition.Offsite engagements": "站外互动",
  "condition.Posts": "帖子",
  "condition.Post comments": "帖子评论",
  "condition.Post reactions": "帖子心情",
  "condition.Content views": "内容查看",
  "condition.Clicks to play video": "点击播放视频",
  "condition.Question answers": "问题回答",
  "condition.New messaging connections": "新增消息联系人数量",
  "condition.Cost per new messaging connection": "单次新增消息联系人费用",
  "condition.Messaging replies": "消息回复次数",
  "condition.Cost per messaging reply": "单次消息回复费用",

  "Action.Scale budget by target field": "根据目标调整预算",

  "Action.General": "常规",
  "Action.Start": "开启",
  "Action.Pause": "停止",
  "Action.Close other ads when Incr Complete Payment": "一个出单关闭其他广告",

  "Action.Budget": "预算",
  "Action.Increase budget by $": "增加预算（$）",
  "Action.Increase budget by %": "增加预算（%）",
  "Action.Decrease budget by $": "降低预算（$）",
  "Action.Decrease budget by %": "降低预算（%）",
  "Action.Set new budget $": "设置新的预算",

  "Action.Bid(Conversation bid)": "出价（转化出价）",
  "Action.Increase bid by $": "提高出价（$）",
  "Action.Increase bid by %": "提高出价（%）",
  "Action.Decrease bid by $": "降低出价（$）",
  "Action.Decrease bid by %": "降低出价（%）",
  "Action.Set new bid $": "设置新的出价",

  "condition.Facebook feeds(desktop)": "Facebook 动态(桌面版)",
  "condition.Facebook feeds (mobile)": "Facebook动态(移动版)",
  "condition.Facebook right column": "Facebook 右边栏",
  "condition.Instagram feed": "Instagram 动态",
  "condition.Instagram Stories": "Instagram 快拍",
  "condition.Audience Network": "Audience Network",
  "condition.Messenger inbox": "收件箱",
  "condition.Facebook Marketplace": "Facebook Marketplace",


  "condition.App Installs": "应用安装量",
  "condition.Brand awareness": "品牌知名度",
  "condition.Clicks on your ad": "广告点击量",
  "condition.Engaged users": "互动用户",
  "condition.FBX usage": "FBX 使用率",
  "condition.Event response": "活动回应次数",
 
  "condition.Offer claims": "优惠领取",
  "condition.Conversions": "转化量",
  "condition.Page engagement": "公共主页互动",
  "condition.Page Likes": "公共主页获赞数",
  "condition.Post Engagement": "帖文互动次数",
  "condition.Daily unique reach": "单日独立覆盖人数",
  "condition.Replies": "回复次数",
  "condition.Social impressions": "带社交信息的广告展示次数",
  "condition.10-second video views": "观看视频达 10 秒的次数",
  

};
